module.exports = __webpack_public_path__ + "img/car_21.c6799148.jpg";